import React from "react";
import { connect } from "react-redux";
import { getCmsBlocks } from "@store/app/actions";

const StaticBlock = ({ blockIdentifier, cmsBlocks, getCmsBlocks }) => {
  if (blockIdentifier) {
    getCmsBlocks([blockIdentifier]);

    if (cmsBlocks[blockIdentifier]) {
      // TODO: CMS blocks content should be migrated to Content Editor
      return (
        <div
          className="Cms"
          dangerouslySetInnerHTML={{ __html: cmsBlocks[blockIdentifier] }}
        />
      );
    }
  }

  // No data
  return null;
};

export default connect(
  (state) => ({
    cmsBlocks: state.app.cmsBlocks,
  }),
  { getCmsBlocks }
)(StaticBlock);
